import { render, staticRenderFns } from "./PopupBannerTable.vue?vue&type=template&id=67073e22"
import script from "./PopupBannerTable.vue?vue&type=script&lang=js"
export * from "./PopupBannerTable.vue?vue&type=script&lang=js"
import style0 from "./PopupBannerTable.vue?vue&type=style&index=0&id=67073e22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports